import { memo, useState, } from "react";
import Form from "../../components/Form";
import {
    getMaleFamilyTree,
    getAnimalsByGenderAndStatus,
} from "../../api/index.js";
import { Box, Typography, Button } from "@mui/material"
import Spinner from "../../components/Spinner.js";
import useSelectStyles from "../../components/styles/Select.js";
import SelectOwnerForm from "../../components/forms/OwnerSelect.js"
import { useSnackbar } from "../../utils/index.js"
import MaleAnimalTreePdf from "../../components/info-pdfs/MaleAnimalTree.js"


const MaleFamilyTree = () => {
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedMaleAnimals, setFetchedMaleAnimals] = useState([]);
    const [animalsDropdownValues, setAnimalsDropdownValues] = useState([]);
    const [familyTree, setFamilyTree] = useState([]);
    const [step, setStep] = useState(1);
    const [selectedAnimal, setSelectedAnimal] = useState(null);

    const classes = useSelectStyles();
    const { error } = useSnackbar();

    const fetchMaleAnimals = async (selOwner) => {
        setIsLoading(true);
        try {
            const { success: scs, animals, message } = await getAnimalsByGenderAndStatus(selOwner, "male", "alive");
            if (scs) {
                setStep(2);
                setFetchedMaleAnimals(animals);
                setAnimalsDropdownValues(
                    animals.map((animal) => ({
                        value: animal?.registrationCode,
                        text: animal?.registrationCode,
                    }))
                );
            } else {
                error(message);
            }
        } catch (err) {
            error("Failed to fetch animals");
        }
        setIsLoading(false);
    }


    const selectMaleAnimalFormContent = [
        {
            customType: "dropdown",
            id: "animal",
            items: animalsDropdownValues,
            placeholder: "Κωδικός Κριού",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ];

    const handleMaleAnimalSelect = async (values) => {
        setIsLoading(true);
        const selectedAnimalObj = fetchedMaleAnimals.find((man) => man?.registrationCode === values?.animal);
        setSelectedAnimal(selectedAnimalObj)
        try {
            const { success: scs, data, message } = await getMaleFamilyTree(selectedAnimalObj?._id);
            if (scs) {
                setFamilyTree(data);
                setStep(3);
            } else {
                error(message);
            }
        } catch (err) {
            error(err)
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <SelectOwnerForm
                    setSelectedOwner={setSelectedOwner}
                    title={"Επιλέξτε Εκτροφή"}
                    method={fetchMaleAnimals}
                    screenCase={"MaleFamilyTree"}
                />
            )}
            {step === 2 && (
                <>
                    <Box className={classes.outerBox}>
                        {console.log(familyTree)}
                        <Box container flexDirection="column" className={classes.innerBox}>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επιλέξτε τον κριό του οποίου το γενεαλογικό δέντρο θέλετε να δείτε
                            </Typography>
                            <Form content={selectMaleAnimalFormContent} onSubmit={handleMaleAnimalSelect} />
                            <Button
                                onClick={() => setStep(1)}
                                sx={{
                                    marginTop: "1rem",
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "third",
                                    color: "secondary.main",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    variant: "h5",
                                }}
                            >
                                Πίσω
                            </Button>
                        </Box>
                    </Box>
                </>
            )}
            {step === 3 && (
                <MaleAnimalTreePdf
                    fetchedData={familyTree}
                    selectedAnimal={selectedAnimal}
                    selectedOwner={selectedOwner}
                />
            )}
        </>
    )
};

export default memo(MaleFamilyTree)